<script setup>
import { ArrowRightIcon, ChevronRightIcon } from '@heroicons/vue/24/outline'
import { index as contactIndex } from '@/actions/App/Http/Controllers/ContactController'

defineProps({
    service: {
        type: Object,
        required: true,
    },
})
</script>

<template>
    <div
        :key="service.name"
        class="group hover:ring-brand-primary/40 relative flex flex-col justify-between overflow-hidden rounded-4xl bg-gray-50 ring-1 shadow-gray-100 ring-gray-100 transition-all duration-300 hover:bg-white hover:shadow-lg"
    >
        <div class="p-8">
            <div
                class="bg-brand-primary/10 text-brand-primary mb-6 inline-flex size-14 items-center justify-center rounded-xl transition-colors duration-300"
            >
                <component
                    :is="service.icon"
                    class="size-7"
                />
            </div>

            <h3 class="text-xl font-semibold text-gray-900">{{ service.name }}</h3>
            <p class="mt-3 text-gray-600">{{ service.description }}</p>

            <ul class="mt-6 space-y-2">
                <li
                    v-for="feature in service.features"
                    :key="feature"
                    class="flex items-center text-sm text-gray-600"
                >
                    <ChevronRightIcon class="text-brand-primary mr-2 size-4 shrink-0" />
                    {{ feature }}
                </li>
            </ul>

            <p
                v-if="service.footer"
                class="mt-4 text-sm font-medium text-gray-700"
            >
                {{ service.footer }}
            </p>
        </div>

        <div class="w-full p-2">
            <Link
                :href="contactIndex().url + '#demand-form'"
                class="bg-brand-primary inline-flex w-full items-center rounded-full px-4 py-4 text-sm font-semibold text-white"
            >
                <span class="absolute inset-0" />

                Mám zájem o tuto službu
                <ArrowRightIcon class="ml-2 size-4 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
        </div>
    </div>
</template>
